import type { TOC } from '@ember/component/template-only'
import type { AssessmentScoresReRoute } from 'teacher-ui-client/reporting/ui-scope/re/assessment-scores/route'
import { t } from 'ember-intl'
import { array } from '@ember/helper'
import { ExportType } from 'teacher-ui-client/components/reporting/export-select'
import ReportingTeacherUiHeader from 'teacher-ui-client/components/reporting/teacher-ui-header'
import fullGradeName from 'teacher-ui-client/helpers/full-grade-name'
import ReportingDetailedControls from 'teacher-ui-client/components/reporting/detailed-controls'
import ReportingNoDataMessageIf from 'teacher-ui-client/components/reporting/no-data-message-if'
import { not } from 'ember-truth-helpers'
import isSubco from 'teacher-ui-client/helpers/is-subco'
import RouteTemplate from 'ember-route-template'
import { AssessmentScoresHistory } from 'teacher-ui-client/components/giraffe/charts/assessment-scores/history'
import { AssessmentScoresAverages } from 'teacher-ui-client/components/giraffe/charts/assessment-scores/averages'
import { Precinct } from 'teacher-ui-client/utils/precincts'

interface Signature {
  model: ModelFor<AssessmentScoresReRoute>
}

export const ReAssessmentScores: TOC<Signature> = <template>
  <ReportingTeacherUiHeader @title={{t "reporting.pageTitles.assessmentScores.re"}} />

  <ReportingDetailedControls
    @students={{@model.scopedStudents}}
    @exportOptions={{array ExportType.print}}
    @isDataPresent={{if @model.assessmentScoresAverages true false}}
    @showScopePicker={{true}}
    @showDatePicker={{true}}
    @studentRouteName="reporting.ui-scope.re.student-summary"
  />

  <ReportingNoDataMessageIf @on={{not @model.assessmentScoresAverages}}>
    {{#each @model.assessmentScoresAverages as |gradeData|}}
      <div
        class="border-dusty-black-50 shadow-dusty-black-100 print:border-dusty-black-200 my-10 h-76 rounded-md border bg-white shadow-md print:rounded-none print:shadow-none"
      >
        <AssessmentScoresAverages
          @data={{gradeData}}
          @title={{t "reporting.chartTitles.assessmentScoresAverages.re"}}
          @tooltip={{t "reporting.tooltips.assessmentScoresAverages.re"}}
          @grade={{fullGradeName gradeData.grade_position}}
          @precinct={{Precinct.RE_READING}}
        />
      </div>
    {{/each}}
    {{#if @model.assessmentScoresHistory}}
      <AssessmentScoresHistory
        data-test-assessment-scores-history
        class="mt-8"
        @tooltip={{t "reporting.tooltips.assessmentScoresHistory.re" htmlSafe=true}}
        @assessmentScoresHistoryData={{@model.assessmentScoresHistory}}
        @subco={{(isSubco)}}
        @students={{@model.scopedStudents}}
        @uiScope={{@model.uiScope.scope}}
        @product={{@model.product}}
      />
    {{/if}}
  </ReportingNoDataMessageIf>
</template>

export default RouteTemplate(ReAssessmentScores)
